type TSpinner = {
  className?: string;
  size?: number;
};

const Spinner = ({ className, size = 40 }: TSpinner): JSX.Element => {
  return (
    <div
      className={`dr-w-full dr-flex dr-justify-center dr-items-center ${className}`}
    >
      <svg
        className="dr-animate-spin"
        id="svg-spinner"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 48 48"
      >
        <circle cx="24" cy="4" r="2.5" className="fill-current opacity-100" />
        <circle
          cx="12.19"
          cy="7.86"
          r="2.5"
          className="fill-current opacity-90"
        />
        <circle
          cx="5.02"
          cy="17.68"
          r="2.5"
          className="fill-current opacity-80"
        />
        <circle
          cx="5.02"
          cy="30.32"
          r="2.5"
          className="fill-current opacity-70"
        />
        <circle
          cx="12.19"
          cy="40.14"
          r="2.5"
          className="fill-current opacity-60"
        />
        <circle cx="24" cy="44" r="2.5" className="fill-current opacity-50" />
        <circle
          cx="35.81"
          cy="40.14"
          r="2.5"
          className="fill-current opacity-40"
        />
        <circle
          cx="42.98"
          cy="30.32"
          r="2.5"
          className="fill-current opacity-30"
        />
        <circle
          cx="42.98"
          cy="17.68"
          r="2.5"
          className="fill-current opacity-20"
        />
        <circle
          cx="35.81"
          cy="7.86"
          r="2.5"
          className="fill-current opacity-10"
        />
      </svg>
    </div>
  );
};

export default Spinner;
